import { render, staticRenderFns } from "./BookingManualActions.vue?vue&type=template&id=60871c2c&"
import script from "./BookingManualActions.vue?vue&type=script&lang=js&"
export * from "./BookingManualActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports